import {FormattedMessage} from "react-intl"
import React from "react"
import moment from "moment"

export default {
	load() {
		return {
			fields: {
				templateId: {
					value: "request_examination_radiofarmakom"
				},
				name: {},
				nameForm: {
					label: <FormattedMessage id="Common.label.fullName" />,
					rules: "required"
				},
				identifierForm: {
					label: <FormattedMessage id="Patient.labels.IDNumber" />,
					rules: "required"
				},
				identifier: {},
				address: {},
				addressForm: {
					label: "Adresa"
				},
				phoneForm: {
					label: "Tel. pacienta"
				},
				phone: {},
				insurerForm: {
					label: "Z.P.",
					rules: "required"
				},
				insurerCode: {},
				idDrg: {
					label: "Id. DRG"
				},
				weight: {
					label: "Hmotnosť"
				},
				height: {
					label: "Výška"
				},
				sendingMedicalDevice: {
					label: "Odosielajúce zdravotnícke zariadenie"
				},
				orgunitCode: {
					label: "Kód oddelenia (ambulancie)",
					rules: "required"
				},
				sendingDoctorPhone: {
					label: "Tel. kontakt na odosielajúceho lekára"
				},
				sendingDocotrCode: {
					label: "Kód odosielajúceho lekára",
					rules: "required"
				},
				clinicalDiagnosis: {
					label: "Klinická diagnóza"
				},
				diagnosisNameExt: {},
				diagnosisCodeExt: {},
				typeOfExaminationRequired: {
					label: "Druh požadovaného vyšetrenia"
				},
				question: {
					label: "Ktorá otázka má byť požadovaným vyšetrením zodpovedaná"
				},
				additionalClinicalData: {
					label: "Doplňujúce klinické a laboratórne údaje"
				},
				resultMethod: {
					label: "Výsledky iných zobrazovacích metód"
				},
				drugTreatment: {
					label: "Medikamentózna liečba"
				},
				radioterapy: {
					label: "Rádioterapia"
				},
				operationDelivery: {
					label: "Operačné výkony"
				},
				previousDiagnostic: {
					label: "Predchadzajúca diagnostická alebo terapeutická aplikácia radiofarmák (dátum, druh, prip. výška dávky)"
				},
				datetime: {
					label: "Dátum",
					rules: "required",
					value: moment(),
					type: "date"
				},
				orderDate: {
					label: "Pacient objednaný na vyšetrenie na deň a hodinu",
					rules: "required",
					value: moment()
				},
				date: {
					value: moment().format("DD.MM.YYYY")
				},
				hour: {
					value: moment().format("HH:mm")
				}
				// hour: {
				// 	label: "hodinu"
				// }
			}
		}
	}
}
